import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import "./Website.css";
import "./header.css";
import axios from 'axios';
import { API_URL } from '../../constants/api';
import { decodeToken, getToken,isTokenExpired,
  removeToken} from "../../utils/TokenUtils";


function Header() {
  const token=getToken();
   const navigate = useNavigate();

    if (token && isTokenExpired(token)) {
    removeToken();
    navigate("/elearningHome");
  };

   const handleLogout = () => {
    removeToken();
    navigate("/elearningHome");
  };
  const [id,setId]=useState(null);

  useEffect(()=>{
  const token=getToken();
  const iid=decodeToken(token,'id');
  
    setId(iid);
  console.log('id id gettin',id);
  },[id])
  
  

  const [logo, setLogo] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false); // <-- toggle state

  useEffect(() => {
    const get_company = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/users/get-company/user-login`);
        setLogo(response.data.company[0]?.['logo']);
      } catch (e) {
        console.error(e);
      }
    }
    get_company();
  }, []);

  return (
    <header className="header">
      <div className="header-top-bar">
        {/* Logo */}
        <div className="e-learning-logo">
          <img src={`${API_URL}/${logo}`} alt="University Logo" className="uni-logo" />
          <span>E-LEARNING</span>
        </div>

        {/* Hamburger for mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Navigation */}
        <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
           
            {token && !isTokenExpired(token) && (
  <Link to="/student-portal" className="nav-link">
    HOME
  </Link>
)}

{(!token || isTokenExpired(token)) && (
  <Link to="/elearningHome" className="nav-link">
    HOME
  </Link>
)}

          
          <Link to="/about" className="nav-link">ABOUT US</Link>
          

          <details className="dropdown">
            <summary className="nav-link">ACADEMICS ▼</summary>
            <div className="dropdown-content">
              <Link to="/programs" className="dropdown-item">Programs</Link>
              <Link to="/admssionRequirement" className="dropdown-item">Admission Requirements</Link>
            </div>
          </details>

          <Link to="/contact" className="nav-link">CONTACT</Link>
       


       

         {(!token || isTokenExpired(token)) ? (
        <button className="login-btn">
          <Link to="/login/student-login" className="nav-link">
            Login <span className="lock-icon">🔒</span>
          </Link>
        </button>
      ) : (
        // Otherwise show LOGOUT
        <button className="logout-btn" onClick={handleLogout}>
          Logout <span className="lock-icon">🔓</span>
        </button>
      )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
